import React from 'react';
import ServicePage from '../components/ServicePage';
import { getServiceData } from '../data/servicesData';
import { getServiceSEO } from '../utils/serviceSEO';

const TrailerLujoPage: React.FC = () => {
  const serviceData = getServiceData('trailer-de-lujo');

  if (!serviceData) {
    return <div>Servicio no encontrado</div>;
  }

  const seoData = getServiceSEO('trailer-de-lujo', serviceData);

  return (
    <ServicePage
      {...serviceData}
      seoTitle={seoData.title}
      seoDescription={seoData.description}
      seoKeywords={seoData.keywords}
      seoUrl={seoData.url}
      structuredData={seoData.structuredData}
    />
  );
};

export default TrailerLujoPage;